export const MINIMUM_COMPANION_QUANTITY = 0;
export const MAXIMUM_COMPANION_QUANTITY = 4;

export const COMPANION_PLAN_CATEGORY_IDENTIFIER = 'companion_plan';
